import { Component } from 'preact'
import Permissions from '../../category/control/Permissions'
import DynamicSaveBar from '../../ui-components/DynamicSaveBar'
import axios from 'axios'

class KnowledgeBasePermissions extends Component {
  constructor () {
    super()
    this.state = {
      categoryPermissions: {},
      savedCategoryPermissions: {},
      showError: false,
      isLoading: false
    }
    this.setValue = this.setValue.bind(this)
    this.resetChanges = this.resetChanges.bind(this)
    this.savePermissions = this.savePermissions.bind(this)
    this.disableCreatePermissionsList = ['roles.not-activated', 'roles.requires-approval', 'roles.guest', 'roles.banned']
  }

  deepCloneObject (obj) {
    return JSON.parse(JSON.stringify(obj))
  }

  setValue (key, value) {
    const categoryPermissions = Object.assign({}, this.state.categoryPermissions, { [key]: value })
    this.setState({ categoryPermissions, errors: [] })
  }

  hasChanged () {
    return JSON.stringify(this.state.savedCategoryPermissions) !== JSON.stringify(this.state.categoryPermissions)
  }

  resetChanges () {
    this.setState({ categoryPermissions: this.deepCloneObject(this.state.savedCategoryPermissions) })
  }

  savePermissions () {
    const permissionsToSave = this.deepCloneObject(this.state.categoryPermissions)
    const newData = {
      category: this.props.categoryId,
      ...permissionsToSave
    }

    this.setState({ isLoading: true })

    axios.post('/platform/knowledge-base/accessRules', newData)
      .then(() => {
        this.setState({ savedCategoryPermissions: permissionsToSave, isLoading: false })
        this.props.showMessage('success')
        this.props.updateCategory(newData)
      })
      .catch(() => {
        this.props.showMessage('error')
        this.setState({ isLoading: false })
      })
  }

  componentDidMount () {
    this.props.saveUpdates(this.savePermissions)
    this.props.discardChanges(this.resetChanges)

    const concatList = [].concat(this.props.roles.main).concat(this.props.roles.custom)
    this.setValue('permissions', concatList)
    this.setState({ savedCategoryPermissions: JSON.parse(JSON.stringify({
      permissions: concatList
    }))
    })
  }

  componentDidUpdate () {
    this.props.hasTabChanges(this.hasChanged())
  }

  render (props, state) {
    const displaySaveBar = this.hasChanged()
    return (
      <div className='category-permissions'>
        <Permissions
          isKnowledgeBase
          mainCount={props.roles.main.length}
          disableCreatePermissionsList={this.disableCreatePermissionsList}
          permissions={state.categoryPermissions.permissions || []}
          onUpdate={(data) => this.setValue('permissions', data)}
        />
        {
          displaySaveBar ? (
            <DynamicSaveBar
              isLoading={state.isLoading}
              cancelCallback={this.resetChanges}
              saveCallback={this.savePermissions}
            />) : null
        }
      </div>
    )
  }
}

export default KnowledgeBasePermissions
